import gcArrowDownIcon from '../iconDefinitions/gcArrowDownIcon/index.vue';
import gcCloseIcon from '../iconDefinitions/gcCloseIcon/index.vue';
import gcPlayIcon from '../iconDefinitions/gcPlayIcon/index.vue';
import gcCartIcon from '../iconDefinitions/gcCartIcon/index.vue';
import gcArrowRightIcon from '../iconDefinitions/gcArrowRightIcon/index.vue';
import gcAccountIcon from '../iconDefinitions/gcAccountIcon/index.vue';
import gcLockIcon from '../iconDefinitions/gcLockIcon/index.vue';

export const iconComponents = {
  'gc-arrow-down': gcArrowDownIcon,
  'gc-close': gcCloseIcon,
  'gc-play': gcPlayIcon,
  'gc-cart': gcCartIcon,
  'gc-arrow-right': gcArrowRightIcon,
  'gc-account': gcAccountIcon,
  'gc-lock': gcLockIcon,
};

export const iconSizeList = [
  'small',
  'medium',
  'large',
];

export const iconColors = {
  dark: '#000',
  light: '#fff',
};

export const iconList = Object.keys(iconComponents).map(key => key);
export const iconColorNames = Object.keys(iconColors).map(key => key);
